var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.device.product_name == 'edgecaster')?_c('device-updater-edgecaster',{attrs:{"device":_vm.device},on:{"close":_vm.close}}):_vm._e(),(_vm.device.product_name == 'edgecaster_max')?_c('device-updater-edgecaster-max',{attrs:{"device":_vm.device},on:{"close":_vm.close}}):_vm._e(),_c('cloud-updater',{attrs:{"device":_vm.device}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }